import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';
import { UserAuthProvider } from '../../modules/mrk-user-auth/user-auth';
import { User, Operator } from '../../models/models';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class OperatorProvider {

  currentUser: User
  lastOperator: Operator

  private operatorSubject: BehaviorSubject<Operator>

  constructor(private userAuth: UserAuthProvider<User>, private api: ApiProvider) {
    this.operatorSubject = new BehaviorSubject<Operator>(null)

    this.userAuth.userState.subscribe(
      x => {
        this.currentUser = x.user
        if (x.logged) {
          this.api.getOperator(this.currentUser.id).subscribe(operator => {
            this.operatorSubject.next(operator)
            this.lastOperator = operator
          })
        } else {
          this.operatorSubject.next(null)
          this.lastOperator = null
        }

      }
    )
  }

  get currentOperator() {
    return this.operatorSubject.filter(x => x != null)
  }

}



// WEBPACK FOOTER //
// ./src/providers/operator/operator.ts